module.exports = __webpack_public_path__ + "static/media/logo-village-counseling-center.c507f2e6.png";